module.exports = __webpack_public_path__ + "img/banker-green_1920.feedbdb0.png";